<template>
  <div id="edit_profile" v-if="loaded">
    <div class="centered">
        <div class="title_filters">
            <h2 v-text="'עריכת פרופיל ' + (get_me().type === 'lawyer' ? 'עורך דין' : 'יזם')"></h2>
            <div class="parts_filter box_switch">
                <template v-if="get_me().type === 'entrepreneur'">
                    <div :class="{selected: step === 1}" @click="step = 1" v-html="get_word('ent_edit_1')"></div>
                    <div :class="{selected: step === 2}" @click="step = 2" v-html="get_word('ent_edit_2')"></div>
                    <div :class="{selected: step === 3}" @click="step = 3" v-html="get_word('ent_edit_3')"></div>
                    <div :class="{selected: step === 4}" @click="step = 4" v-html="get_word('ent_edit_4')"></div>
                    <div :class="{selected: step === 5}" @click="step = 5">איפוס סיסמא</div>
                </template>
                <template v-if="get_me().type === 'lawyer'">
                    <div :class="{selected: step === 1}" @click="step = 1" v-html="get_word('law_edit_1')"></div>
                    <div :class="{selected: step === 2}" @click="step = 2" v-html="get_word('law_edit_2')"></div>
                    <div :class="{selected: step === 3}" @click="step = 3" v-html="get_word('law_edit_3')"></div>
                    <div :class="{selected: step === 4}" @click="step = 4" v-html="get_word('law_edit_4')"></div>
                    <div :class="{selected: step === 5}" @click="step = 5">איפוס סיסמא</div>
                </template>
            </div>
        </div>
        <div class="step_container">
            <template v-if="get_me().type === 'entrepreneur'">
                <EntrepreneurStepA state="edit"  @update="update" :updatedData="formData" @next="handleNext" v-show="step === 1"/>
                <EntrepreneurStepB state="edit"  @update="update" :key="step" :updatedData="formData" v-show="step === 2"/>
                <EntrepreneurStepC state="edit"  @update="update" :key="step" :updatedData="formData" v-show="step === 3"/>
                <EntrepreneurStepD state="edit"  @update="update" :key="step" :updatedData="formData" v-show="step === 4"/>
            </template>
            <template v-if="get_me().type === 'lawyer'">
                <LawyerStepA state="edit" @update="update" :updatedData="formData" v-show="step === 1"/>
                <LawyerStepB state="edit" @update="update" :key="step" :updatedData="formData" v-show="step === 2"/>
                <LawyerStepC state="edit" @update="update"  :updatedData="formData" v-show="step === 3"/>
                <LawyerStepD state="edit" @update="update" :key="step" :updatedData="formData" v-show="step === 4"/>
            </template>
            <resetPasword v-if="step == 5" />
            <div class="btn" v-if="step != 5" @click="saveData" :class="{disabled: isSave}">שמירה</div>
        </div>
    </div>
  </div>
</template>

<script>
// Entrepreneur
import EntrepreneurStepA from '@/components/signupEntrepreneur/StepA.vue'
import EntrepreneurStepB from '@/components/signupEntrepreneur/StepB.vue'
import EntrepreneurStepC from '@/components/signupEntrepreneur/StepC.vue'
import EntrepreneurStepD from '@/components/signupEntrepreneur/StepD.vue'

// Lawyer
import LawyerStepA from '@/components/signupLawyer/StepA.vue'
import LawyerStepB from '@/components/signupLawyer/StepB.vue'
import LawyerStepC from '@/components/signupLawyer/StepC.vue'
import LawyerStepD from '@/components/signupLawyer/StepD.vue'

import resetPasword from '@/components/resetPasword.vue'

export default {
    components: { EntrepreneurStepA, EntrepreneurStepB, EntrepreneurStepC, EntrepreneurStepD, LawyerStepA, LawyerStepB, LawyerStepC, LawyerStepD, resetPasword },
    data() {
        return {
            loaded: false,
            isSave: false,
            step: 1,
            token: null,
            formData: {},
            newFromData: {}
        }
    },
    mounted() {
        this.loadFormData();
    },
    methods: {
        update(newData) {
            for (const key in newData) {
                // if (this.formData[key] != undefined && this.formData[key] != newData[key] && this.isSave) {
                    // console.log();
                    // console.log(this.formData, key);
                    // console.log(this.formData[key], newData[key])
                    // this.isSave = false
                // }
                this.newFromData[key] = newData[key]
                // if (this.updatedData[key]) this.formData[key] = this.updatedData[key];
            }
        },
        saveData() {
            this.api({ action: 'user/update_user', data: {...this.newFromData, type: this.get_me().type, token: this.get_me().token} }, (data) => {
                if (data.data && data.data.token) this.token = data.data.token;

                if (data.data) {
                    this.alert('עודכן בהצלחה');
                } else {
                    this.alert('עדכון נכשל נסה שוב מאוחר יותר');
                }
            });
        },
        loadFormData() {
            this.api({ action: 'user/get_user_data', data: { token: this.get_me().token}}, (data)=>{
                if (data.data) {
                    data.data["email"] = data.data["username"]
                    data.data["contact_name"] = data.data["display_name"]
                    data.data["company_office_phone"] = data.data["phone"]
                    data.data["company_logo"] = data.data["pic"];
                    this.formData = data.data;
                    this.newFromData = data.data;
                    this.loaded = true;
                }
            })
        }
    }
}
</script>

<style lang="scss">
#edit_profile { 
    // background: #fff !important;
    .centered { display: flex; flex-direction: column; gap: var(--gap_xbig);
        .title_filters { display: flex; flex-direction: column; gap: var(--gap_small);}
        .step_container { background: #fff; max-width: 600px; display: flex; flex-direction: column; gap: var(--gap_xbig); border: 2px solid var(--dark_blue); padding: var(--gap_xmid); box-sizing: content-box;border-radius: var(--radius_md);}
    }
}
</style>